const NotificationsTypes = {
    ERROR: 'danger',
    SUCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
    DEFAULT: 'default'
}

export default NotificationsTypes